// extracted by mini-css-extract-plugin
module.exports = {"card_wrapper":"card_wrapper__3R0op"};